import 'css-chunksrc/client/common/layout/zonesList/styles.scss';export default {
  "zonesList": "_zonesList_18m53_1",
  "item": "_item_18m53_5",
  "header": "_header_18m53_16",
  "activeZones": "_activeZones_18m53_24",
  "zoneCreation": "_zoneCreation_18m53_28",
  "selectedZone": "_selectedZone_18m53_32",
  "name": "_name_18m53_36",
  "addZoneButton": "_addZoneButton_18m53_40",
  "closed": "_closed_18m53_47",
  "loader": "_loader_18m53_63",
  "loaderMain": "_loaderMain_18m53_71"
};